import { render, staticRenderFns } from "./ShareLimitInput.vue?vue&type=template&id=341d8aca&"
import script from "./ShareLimitInput.vue?vue&type=script&lang=js&"
export * from "./ShareLimitInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports